import React from 'react';
import { Link } from 'react-router-dom';
import './popularCategories.css'

const PopularCategories = () => {

    return (
        <div className='popular-category'>
            <div className='titles'>
                <div>
                    <h2>Popular Occasions</h2>
                    <p>The most popular occasion for other bastards to ruin.</p>
                </div>
                <div className='shop-all-button'>
                    <Link to='/all'><p>Shop all</p></Link>
                </div>


            </div>
            <div className='popular-category-item'>
                <Link to='/birthday'>
                    <div className="item">
                        <img alt='' className="product-image" src="https://imagedelivery.net/IyOC7uTDWFgfD5VgVJbU5A/e58c5fba-abc8-4014-e134-1e062aa94c00/public" />
                        <p>Birthday</p>
                    </div>
                </Link>
                <Link to='/wedding'>
                    <div className="item">
                        <img alt='' className="product-image" src="https://imagedelivery.net/IyOC7uTDWFgfD5VgVJbU5A/0878b960-c668-472e-2e90-448d26758e00/public" />
                        <p>Weddings</p>
                    </div>
                </Link>
                <Link to='/engagement'>
                    <div className="item">
                        <img alt='' className="product-image" src="https://imagedelivery.net/IyOC7uTDWFgfD5VgVJbU5A/9dd637f6-e07f-43dc-97fa-d99c7e7fd300/public" />
                        <p>Engagements</p>
                    </div>
                </Link>
                <Link to='/get-well'>
                    <div className="item">
                        <img alt='' className="product-image" src="https://imagedelivery.net/IyOC7uTDWFgfD5VgVJbU5A/ea00eb1f-946f-4b4c-88ba-63a061d95000/public" />
                        <p>Get Well</p>
                    </div>
                </Link>
                </div>
  
        </div>
    )
}

export default PopularCategories
